import { ErrorResponse } from '../../../models/error.model';
import { ServicesService } from 'src/app/services/services.service';
import { UtilsService } from '../../../services/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Service } from '../../../models/service.model';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-edit-service',
    templateUrl: './edit-service.component.html',
    styleUrls: ['./edit-service.component.scss']
})
export class EditServiceComponent implements OnInit {

    service?: Service;

    generalSectionFG = new UntypedFormGroup({
        codigo: new UntypedFormControl('', [Validators.required]),
        nombre: new UntypedFormControl('', [Validators.required]),
        descripcion: new UntypedFormControl('', [Validators.required]),
        porcentajeDefault: new UntypedFormControl('', [Validators.required]),
        topeMaximoDefault: new UntypedFormControl('', [Validators.required]),
        topeMinimoDefault: new UntypedFormControl('', [Validators.required]),
        pagador: new UntypedFormControl('', [Validators.required]),
        tipoProducto: new UntypedFormControl('GARANTIA', [Validators.required]),
    });

    constructor(
        private route: ActivatedRoute,
        private utilsService: UtilsService,
        private router: Router,
        private servicesService: ServicesService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.servicesService.getServiceById(params.id).subscribe(service => {
                    this.service = service;
                    this.fillFormsWithOwnerData();
                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener datos del servicio', error.error?.descripcion));
            }
        });
    }

    fillFormsWithOwnerData() {
        this.generalSectionFG.setValue({
            codigo: this.service.codigo,
            nombre: this.service.nombre,
            descripcion: this.service.descripcion,
            porcentajeDefault: this.service.porcentajeDefault,
            topeMaximoDefault: this.service.topeMaximoDefault ?? 0,
            topeMinimoDefault: this.service.topeMinimoDefault ?? 0,
            pagador: this.service.pagador,
            tipoProducto: this.service.tipoProducto
        });
    }

    getResultingService() {
        return {
            id: this.service?.id,
            codigo: this.generalSectionFG.value.codigo,
            nombre: this.generalSectionFG.value.nombre,
            descripcion: this.generalSectionFG.value.descripcion,
            porcentajeDefault: this.generalSectionFG.value.porcentajeDefault,
            topeMaximoDefault: this.generalSectionFG.value.topeMaximoDefault,
            topeMinimoDefault: this.generalSectionFG.value.topeMinimoDefault,
            pagador: this.generalSectionFG.value.pagador,
            tipoProducto: this.generalSectionFG.value.tipoProducto
        } as Service;
    }

    save() {
        if (!this.generalSectionFG.valid) {
            this.generalSectionFG.markAllAsTouched();
            return;
        }
        const service: Service = this.getResultingService();
        if (this.service) {
            this.servicesService.editService(service).subscribe(_ => {
                this.utilsService.alert('Servicio actualizado', `El servicio "${service.nombre}" fue actualizado correctamente.`);
                this.router.navigate(['servicios']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al modificar servicio', error.error?.descripcion));
        } else {
            this.servicesService.createService(service).subscribe(_ => {
                this.utilsService.alert('Servicio creado', `El servicio "${service.nombre}" fue creado correctamente.`);
                this.router.navigate(['servicios']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al crear servicio', error.error?.descripcion));
        }
    }

    cancel() {
        this.router.navigate(['servicios']);
    }

}
